module.exports = __webpack_public_path__ + "img/contacts.b37cb940.png";